import React, { useEffect, useState } from 'react';
import { APIROOT } from '../../Helpers/configs';

import { filterMethod, handleClose } from '../../Helpers/helpers';

import { ticketTypoTitle } from '../shared/commonStyle';

import { expiryDate } from '../../Helpers/helpers';

import {
  Grid,
  TableContainer,
  Table,
  TableRow,
  TableHead,
  TableCell,
  TableBody,
  Button,
  Autocomplete,
  Typography,
  TextField,
  Modal,
  Box,
} from '@mui/material';

function JobCardCabinetDetails(props) {
  const updateCabRow = props.updateCabRow;
  const customerName = props.customerName;
  const removeCabRow = props.removeCabRow;
  // const getMyRowData = props.getMyRowData;
  const [filteredSerialNumbersList, setFilteredSerialNumbersList] = useState();

  // const [filteredSerialNumbersList, setFilteredSerialNumbersList] = useState(
  //   []
  // );

  const [cabinetsList, setCabinetsList] = useState(null);
  const [serialList, setSerialsList] = useState([]);
  const [openCabModal, setOpenCabModal] = useState(false);
  const handleOpenCabModal = () => setOpenCabModal(true);
  const handleCloseCabModal = () => setOpenCabModal(false);

  const [openCabinet, setOpenCabinet] = useState({});
  const [openCabType, setOpenCabType] = useState({});
  const [openSerial, setOpenSerial] = useState({});
  const [openDescription, setOpenDescription] = useState('');
  const [openId, setOpenId] = useState('');
  const [expiryDateVal, setExpiryDateVal] = useState('');

  const handleCabinet = (data) => {
    setOpenId(data.id);
    setOpenCabType({ id: data.cabId, name: data.cabType });
    setOpenSerial({ id: data.serialId, name: data.serialNo });
    setOpenDescription(data.description);
    handleOpenCabModal();
  };

  const rowsData = props.rowsData;
  // let onBlurEventsCapture = props.onBlurEventsCapture;

  const [fullSeriaLIst, setFullSerialList] = useState([]);
  const setFilterItems = () => {
    serialsByCustomer(customerName).then((data) => {
      mapAvailableCabinetTypes(data?.data?.value);
      setFullSerialList(data?.data?.value);
    });
    serialsByCustomer(customerName, openCabType?.id).then((data) => {
      // mapAvailableCabinetTypes(data?.data?.value);
      mapAvailableSerials(data?.data?.value);
    });
    console.log(fullSeriaLIst);
  };

  // useEffect(() => {

  // }, [customerName, openCabType]);

  useEffect(() => {
    setFilterItems();
  }, [customerName, openCabType]);

  // useEffect(() => {
  //   serialsByCustomer(customerName, openCabType.cabId).then((data) => {
  //     console.log(data.data.value);
  //     setSerialsList(data.data.value);
  //   });
  // }, [customerName, openCabType]);

  async function mapAvailableCabinetTypes(fullSerialList) {
    let cabinetsTypes;
    cabinetsTypes = fullSerialList.map((obj) => ({
      id: obj.cabinet_type_id,
      name: obj.cabinet_name,
      install_date: obj.install_date,
      warranty_period: obj.warranty_period,
    }));
    console.log(cabinetsTypes);
    let distinctCabinetTypes;
    try {
      let cab = 'name';
      distinctCabinetTypes = [
        ...new Map(cabinetsTypes.map((obj) => [obj[cab], obj])).values(),
      ];
    } catch (error) {
      distinctCabinetTypes = [...cabinetsTypes];
    }

    setCabinetsList(distinctCabinetTypes);
  }

  const handleListChange = (event, newValue) => {
    const eventTarget = event.target?.parentNode?.id.split('-').shift();
    let eventValue = newValue;
    setAutocompleteValue(eventTarget, eventValue);
  };

  const handleInput = (event) => {
    setOpenDescription(event.target.value);
  };

  const handleCabRemove = (data) => {
    removeCabRow(data);
  };

  const setAutocompleteValue = (event, newValue) => {
    switch (event) {
      case 'cabinetType':
        let value = [];

        setOpenCabType(newValue);
        setOpenSerial({});
        break;
      case 'serialNumber':
        setOpenSerial(newValue);
        break;
      default:
        break;
    }
  };

  const combineData = () => {
    setFilterItems();
    // const expire =

    let blob = {
      id: openId,
      cabId: openCabType.id,
      cabType: openCabType.name,
      serialId: openSerial.id,
      serialNo: openSerial.name,
      description: openDescription,
      exp: expiryDateVal,
    };
    return blob;
  };

  const calculateWarrantee = (list, serial) => {
    const dateGroup = list.filter((cab) => {
      return cab.serial_number === serial.name;
    });

    const dateGroupObj = dateGroup[0];

    console.log(dateGroup[0]);

    let data =
      dateGroupObj === undefined
        ? ''
        : expiryDate(dateGroup[0].install_date, dateGroup[0].warranty_period);

    console.log(data);
    setExpiryDateVal(data);
    return data;
  };

  const cabinetUpdate = () => {
    const expDate = calculateWarrantee(fullSeriaLIst, openSerial);
    const DataBlob = { ...combineData(), exp: expDate };
    updateCabRow(DataBlob);
    handleCloseCabModal();
  };

  // useEffect(() => {
  //   serialsByCustomer(location.state.customer_name).then((data) => {
  //     mapAvailableSerials(data.data.value);
  //   });
  // }, [location.state]);

  async function mapAvailableSerials(fullSerialList) {
    let cabinetsTypes;
    cabinetsTypes = fullSerialList.map((obj) => {
      return {
        id: obj.id,
        name: obj.serial_number,
        install_date: obj.install_date,
        warranty_period: obj.warranty_period,
      };
    });
    let distinctCabinetTypes;
    try {
      let cab = 'name'; ///FIX HERE
      distinctCabinetTypes = [
        ...new Map(cabinetsTypes.map((obj) => [obj[cab], obj])).values(),
      ];
    } catch (error) {
      distinctCabinetTypes = [...cabinetsTypes];
    }
    setFilteredSerialNumbersList(distinctCabinetTypes);
  }

  return (
    <Grid item xs={12} md={12} style={{ textAlign: 'left' }}>
      <TableContainer>
        <Table
          sx={{ minWidth: 650, border: 1 }}
          size='small'
          aria-label='a dense table'
        >
          <TableHead>
            <TableRow>
              <TableCell
                id='cabinetTypeHead'
                key='cabinetTypeHead'
                name='cabinetTypeHead'
                // onClick={handleClick}
                sx={{ borderBottom: 1, fontWeight: '700' }}
                width='25%'
              >
                Cabinet Type
              </TableCell>
              <TableCell
                id='serialNoHead'
                key='serialNoHead'
                name='serialNoHead'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                width='25%'
                align='left'
              >
                Serial No
              </TableCell>
              <TableCell
                id='descriptionHead'
                key='descriptionHead'
                name='descriptionHead'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                align='left'
              >
                Description Of Work Done
              </TableCell>
              <TableCell
                className='d-print-none'
                id='actionHead'
                key='actionHead'
                name='actionHead'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                width='10%'
                align='left'
              >
                Action
              </TableCell>
              {/* <TableCell
                id='action'
                key='action'
                name='action'
                sx={{ borderLeft: 1, borderBottom: 1, fontWeight: '700' }}
                align='left'
              >
                Action
              </TableCell> */}
            </TableRow>
          </TableHead>
          <TableBody>
            {rowsData.map((row) => (
              <TableRow
                key={row.id}
                name={row.id}
                id={row.id}
                sx={{
                  '&:last-child td, &:last-child th': { borderBottom: 0 },
                }}
              >
                <TableCell
                  onClick={() => handleCabinet(row)}
                  id='cabinetType'
                  key='cabinetType'
                  name='cabinetType'
                  defaultValue={row.cabType}
                  // onBlurCapture={(event) => {
                  //   onBlurEventsCapture(event, row);
                  // }}
                  cabinetType
                  sx={{
                    borderBottom: 1,
                    background:
                      row.description === undefined ||
                      row.description === '' ||
                      row.description === null
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  component='th'
                  scope='row'
                >
                  {row.cabType}
                </TableCell>
                <TableCell
                  onClick={() => handleCabinet(row)}
                  id='serialNo'
                  key='serialNo'
                  name='serialNo'
                  // onClick={() => onBlurEventsCapture(row)}
                  // defaultValue={row.serialNo}
                  // onBlurCapture={onBlurEventsCapture}
                  // onBlurCapture={(event) => {
                  //   onBlurEventsCapture(event, row);
                  // }}
                  sx={{
                    borderLeft: 1,
                    borderBottom: 1,
                    background:
                      row.description === undefined ||
                      row.description === '' ||
                      row.description === null
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  align='left'
                >
                  {row.serialNo}
                </TableCell>
                <TableCell
                  onClick={() => handleCabinet(row)}
                  id='description'
                  key='description'
                  name='description'
                  // defaultValue=
                  // onClick={() => onBlurEventsCapture(row)}
                  // onBlurCapture={(event) => {
                  // onBlurEventsCapture(event, row);
                  //   console.log(event.target.id, row);
                  // }}
                  sx={{
                    borderLeft: 1,
                    borderBottom: 1,
                    background:
                      row.description === undefined ||
                      row.description === '' ||
                      row.description === null
                        ? '#00334433'
                        : 'none',
                  }}
                  // contentEditable
                  align='left'
                >
                  {row.description || ''}
                </TableCell>

                <TableCell
                  onClick={() => handleCabRemove(row.id)}
                  className='d-print-none'
                  // onClick={() => console.log(row)}
                  id='cabRemove'
                  key='cabRemove'
                  name='cabRemove'
                  value={row.qty}
                  // onBlurCapture={console.log(row)}
                  // onClick={() => onBlurEventsCapture(row)}
                  cabinetType
                  sx={{ borderLeft: 1, borderBottom: 1 }}
                  // contentEditable
                  component='th'
                  scope='row'
                >
                  <Button size='small'>Remove</Button>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        </Table>
      </TableContainer>
      <Modal
        id='cabinetsModal'
        open={openCabModal}
        onClose={handleCloseCabModal}
        aria-labelledby='modal-cabinets'
        aria-describedby='modal-modal-cabinets'
      >
        <Box sx={style}>
          <Grid
            container
            xs={12}
            md={12}
            flexDirection='row'
            rowGap={1}
            // columnGap={1}
            alignContent='flex-start'
          >
            <Grid
              container
              xs={11}
              md={11}
              flexDirection='row'
              rowGap={1}
              columnGap={1}
              alignContent='flex-start'
            >
              <Grid item xs={12} md={2.5}>
                <Typography style={ticketTypoTitle}>Cabinet Type:</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  sx={{
                    width: '100%',
                    background: '#ffffff',
                    padding: 0,
                  }}
                  name='cabinetType'
                  key='cabinetType'
                  id='cabinetType'
                  variant='standard'
                  size='small'
                  value={openCabType}
                  // value={{ id: '404', name: 'not defined' }}
                  // defaultValue={{ id: '123', name: '123' }}
                  onChange={handleListChange}
                  disablePortal
                  options={cabinetsList}
                  filterOptions={filterMethod}
                  getOptionLabel={(option) => option.name}
                  renderInput={(params) => <TextField {...params} />}
                  isOptionEqualToValue={(option, value) => {
                    return option.name === value.name ? true : false;
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.5}>
                <Typography style={ticketTypoTitle}>Serial Number:</Typography>
              </Grid>
              <Grid item xs={12} md={3}>
                <Autocomplete
                  sx={{
                    width: '100%',
                    background: '#ffffff',
                    padding: 0,
                  }}
                  name='serialNumber'
                  key='serialNumber'
                  id='serialNumber'
                  variant='standard'
                  size='small'
                  // value={serialNumber || { id: '404', name: 'not defined' }}
                  value={openSerial}
                  onChange={handleListChange}
                  disablePortal
                  options={filteredSerialNumbersList}
                  filterOptions={filterMethod}
                  getOptionLabel={(option) => option.name || ''}
                  renderInput={(params) => <TextField {...params} />}
                  isOptionEqualToValue={(option, value) => {
                    return option.name === value.name ? true : false;
                  }}
                />
              </Grid>
              <Grid item xs={12} md={2.5}>
                <Typography style={ticketTypoTitle}>
                  Description Of Work Done:
                </Typography>
              </Grid>
              <Grid item xs={12} md={8.7}>
                <TextField
                  value={openDescription}
                  onChange={handleInput}
                  name='whatWasDone'
                  key='whatWasDone'
                  id='whatWasDone'
                  fullWidth
                />
              </Grid>
            </Grid>
          </Grid>

          <Button
            sx={{ margin: '20px 0 0 20px', float: 'right' }}
            variant='contained'
            type='submit'
            color='success'
            className='btn btn-primary'
            onClick={() => cabinetUpdate()}
          >
            Save
          </Button>
        </Box>
      </Modal>
    </Grid>
  );
}

// const [cabinetTypes ]

export default JobCardCabinetDetails;

//STYLE
const style = {
  position: 'absolute',
  top: '50%',
  left: '50%',
  transform: 'translate(-50%, -50%)',
  width: '80%',
  bgcolor: 'background.paper',
  border: '2px solid #000',
  boxShadow: 24,
  p: 4,
};

//FUNCTIONS
async function serialsByCustomer(customerName, cabinetType) {
  let JWT = localStorage.getItem('JWT_Key');
  let headers = {
    'content-type': 'application/JSON',
  };

  if (JWT) {
    headers['x-api-key'] = JWT;
  }

  const filterBlob =
    cabinetType === null
      ? [
          {
            field: 'store_name',
            search: customerName,
            strict: true,
          },
        ]
      : [
          {
            field: 'store_name',
            search: customerName,
            strict: true,
          },
          {
            field: 'cabinet_type_id',
            search: cabinetType,
            strict: true,
          },
        ];
  let body = {
    pagereq: {
      filter: {
        fullfilter: filterBlob,
      },
    },
  };
  const request = new Request(`${APIROOT}/api/serialnumbers`, {
    method: 'post',
    headers,
    body: JSON.stringify(body),
  });

  const response = await fetch(request);

  const data = response.json();
  return data;
}
